import React, { useEffect } from "react";
import axios from "axios";
import { handleEncodeJson, handleDecodeJSON } from "../../utils/encodeDecodeJson"; // <-- your helper functions

function formatDate() {
    const date = new Date();
    const offset = date.getTimezoneOffset();
    const absOffset = Math.abs(offset);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");
    const tzHours = String(Math.floor(absOffset / 60)).padStart(2, "0");
    const tzMinutes = String(absOffset % 60).padStart(2, "0");
    const tzSign = offset > 0 ? "-" : "+";

    return (
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0") +
      "T" +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      tzSign +
      tzHours +
      ":" +
      tzMinutes
    );
  }

const PaymentPage = () => {
  const handleAirpaySubmit = async () => {
    try {
      const date = formatDate();
      const orderDetails = {
        courseid: 23,
        amount: 2200,
        currency: "356",
        order_date: date.toString(),
      }
      const encodedDataBilldesk = await handleEncodeJson({
        encodeJSON: {
          orderDetails,
          candidateid: 587878,
        },
      });
      const responsedata = await axios.post(
        `${process.env.REACT_APP_API_URL}/air-pay/create-order`,
        {
          encryptedData: encodedDataBilldesk.encryptedData,
        }
      );

      const response = await handleDecodeJSON({
        decodeJSON: responsedata.data.result,
      });

     const { url, ...hiddenFields } = response;

      // Create form dynamically
      const form = document.createElement("form");
      form.method = "POST";
      form.action = url;

      for (const key in hiddenFields) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = hiddenFields[key];
        form.appendChild(input);
      }

      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error creating order:", error);
      alert("Something went wrong.");
    }
  };

  useEffect(() => {
    handleAirpaySubmit();
  });

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h2 className="text-xl mb-4">Redirecting to Payment Gateway...</h2>
      <button
        className="px-4 py-2 bg-blue-600 text-white rounded"
        onClick={handleAirpaySubmit}
      >
        Retry Payment
      </button>
    </div>
  );
};

export default PaymentPage;
